<script setup lang="ts">
import type { DtwinMetricsCounts } from "~/modules/dashboard/models/DtwinMetricsCounts.type";

const props = defineProps<{
  dtwinMetricsCounts: DtwinMetricsCounts;
  dtwinModelFriendlyName: string;
}>();

const { t } = useI18n();

const relevantFirmwareDistribution: ComputedRef<Record<string, number>> =
  computed(() => {
    const firmwareDistributionEntries = Object.entries(
      props.dtwinMetricsCounts,
    );

    // Sort and extract the 3 most relevant firmware distributions
    const mostRelevantFirmwareDistributions = firmwareDistributionEntries
      .sort(([, a], [, b]) => b - a)
      .slice(0, 3);

    // Create a Set of the 3 most relevant firmware distributions keys
    const mostRelevantFirmwareDistributionsKeys = new Set(
      mostRelevantFirmwareDistributions.map(([key]) => key),
    );

    const otherDistributionSum: number = firmwareDistributionEntries.reduce(
      (accumulator: number, [key, value]: [string, number]) => {
        if (!mostRelevantFirmwareDistributionsKeys.has(key)) {
          accumulator += value;
        }
        return accumulator;
      },
      0,
    );

    const relevantFirmwareDistribution = {
      ...Object.fromEntries(mostRelevantFirmwareDistributions),
    };

    if (
      Object.prototype.hasOwnProperty.call(relevantFirmwareDistribution, "")
    ) {
      relevantFirmwareDistribution[t("dashboard.firmwares.unknown")] =
        relevantFirmwareDistribution[""];
      delete relevantFirmwareDistribution[""];
    }

    if (otherDistributionSum > 0) {
      relevantFirmwareDistribution[t("dashboard.firmwares.others")] =
        otherDistributionSum;
    }

    return relevantFirmwareDistribution;
  });
</script>

<template>
  <dashboard-dtwin-doughnut-chart
    :dtwin-metrics-counts="relevantFirmwareDistribution"
    :dtwin-model-friendly-name="dtwinModelFriendlyName"
    :background-colors="['#F18006', '#1B538D', '#002F5D', '#98A2B3']"
  />
</template>
